module Tapas.Bindings {
    export class ToggleClassParent {
        public init(element: any, valueAccessor: () => any, allBindingsAccessor?: KnockoutAllBindingsAccessor, viewModel?: any, bindingContext?: KnockoutBindingContext) {
            if (!bindingContext)
                return;

            element = $(element);
            var value = valueAccessor();

            $(element).click(function () {
                $(this).parent().toggleClass(value);
            });
        }
    };
    ko.bindingHandlers['toggleClassParent'] = new ToggleClassParent();
}
